export default "__VITE_ASSET__Dz0_n2V9__"